import { Directive, HostBinding, Input, type OnInit } from '@angular/core';
import { UiButtonStyle } from './button-style.type';

@Directive({
    selector: 'big-ui-link[bigUiButtonStyle], button[bigUiButtonStyle]',
})
export class ButtonStyleDirective implements OnInit {
    private readonly defaultButtonStyles = [
        'bg-linear-45',
        'shadow-default',
        'dark:shadow-none!',
        'inline-flex',
        'px-6',
        'py-2',
        'transition-[box-shadow,color,background-color]',
        'duration-150',
        'rounded-full',
        'text-base',
        'font-ci',
        'font-medium',
        'outline-0',
        'no-underline',
        'disabled:opacity-75',
        'disabled:cursor-default',
    ];

    private readonly defaultButtonStylesSmall = ['px-4', 'py-1', 'm-2', 'bg-default', 'rounded-md', 'hover:bg-contrast!'];

    @Input() public bigUiButtonStyle: UiButtonStyle = 'primary';
    @Input() public classList = [''];

    public styleMap?: Record<UiButtonStyle, string[]>;

    @HostBinding('class') public get hostClasses(): string {
        if (!this.styleMap?.[this.bigUiButtonStyle]) {
            return '';
        }

        return this.styleMap[this.bigUiButtonStyle].join(' ');
    }

    public ngOnInit(): void {
        // Little workaround for the case we have an unexpected underline
        const linkClass = ['text-left', 'hover:text-primary-light', 'disabled:opacity-75', 'disabled:cursor-default'];

        if (!this.classList.includes('no-underline')) {
            linkClass.push('underline');
        }

        if (!this.classList.includes('flex')) {
            linkClass.push('inline');
        }

        this.styleMap = {
            primary: [...this.defaultButtonStyles, 'text-white', 'from-primary', 'to-primary-light', ...this.classList],
            secondary: [...this.defaultButtonStyles, 'text-primary', 'from-secondary', 'to-secondary-light', ...this.classList],
            // They should be called "chips instead of small"
            smallActive: [...this.defaultButtonStylesSmall, 'bg-primary-light!', 'text-white', ...this.classList],
            smallDefault: [...this.defaultButtonStylesSmall, ...this.classList],
            smallLink: ['px-4', 'py-1', 'm-2', 'text-primary-light', ...this.classList],
            icon: this.classList,
            link: [...linkClass, ...this.classList],
        };
    }
}
